import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import ContentShadow from '../_partials/ContentShadow';
import ImageContent from './ImageContent';
import ZoomModal from './ZoomModal';
import { useImageFile } from './hooks/useImageFile';
import s from './Image.scss';
export var ImageFullView = function (_a) {
    var _b;
    var width = _a.width, height = _a.height, deviation = _a.deviation, isZoomed = _a.isZoomed, onEnterZoomMode = _a.onEnterZoomMode, onExitZoomMode = _a.onExitZoomMode;
    var _c = useImageFile({
        width: width,
        height: height,
        deviation: deviation,
        isZoomed: isZoomed,
    }), file = _c.file, zoomedFile = _c.zoomedFile, isFullscreen = _c.isFullscreen, isPixel = _c.isPixel, drag = _c.drag, dragPreview = _c.dragPreview, canZoom = _c.canZoom;
    if (!file) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], isFullscreen && s['fullscreen']), style: { width: width, height: height } },
        React.createElement(Helmet, null,
            React.createElement("link", __assign({ rel: "preload", href: file.src, as: "image" }, { fetchpriority: 'high' }))),
        isZoomed && zoomedFile && (React.createElement(ZoomModal, { src: zoomedFile.src, srcSet: getSrcSet(deviation), width: zoomedFile.width, height: zoomedFile.height, isPixel: isPixel, onClose: onExitZoomMode })),
        React.createElement(ContentShadow, { content: file, containerSize: { width: width, height: height }, useSmallStage: true, className: s['shadow'] },
            React.createElement("div", { ref: drag },
                React.createElement(ImageContent, { key: file.src, width: width, height: height, file: file, alt: (_b = deviation.title) !== null && _b !== void 0 ? _b : '', isPixel: isPixel, canZoom: canZoom, onZoom: onEnterZoomMode }))),
        dragPreview));
};
ImageFullView.displayName = 'ImageFullView';
export default ImageFullView;
//# sourceMappingURL=Image.js.map